import { styled } from '@mui/material/styles'
import Switch, { SwitchProps } from '@mui/material/Switch'
import Check from '../../../assets/svgs/Check.svg'

const StyledSwitch = styled(Switch)<SwitchProps>(({ theme }) => ({
  width: '8rem',
  height: '3.6rem',
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(44px)',
      color: theme.palette.common.white,
      '&:before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url(${Check})`,
      },
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color: '#b30727',
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '&.MuiSwitch-sizeSmall': {
    width: '4.8rem',
    height: '2.4rem',
    '& .Mui-checked': {
      transform: 'translateX(24px)',
      color: theme.palette.common.white,
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: '2rem',
      height: '2rem',
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: '3.2rem',
    height: '3.2rem',
  },
  '& .MuiSwitch-track': {
    borderRadius: '3.2rem',
    backgroundColor: theme.palette.primary[200],
    opacity: 1,
    transition: {
      duration: 500,
    },
  },
}))

export default StyledSwitch
